// Web stub for expo-sqlite.
// expo-sqlite's web build needs SharedArrayBuffer (cross-origin isolation), which we don't
// enable. On web the app reads from the API instead, so every DB call here is a safe no-op.

function makeStatement() {
  return {
    executeSync: () => ({ getAllSync: () => [], getFirstSync: () => null, resetSync: () => {}, changes: 0, lastInsertRowId: 0 }),
    executeAsync: async () => ({ getAllAsync: async () => [], getFirstAsync: async () => null, resetAsync: async () => {}, changes: 0, lastInsertRowId: 0 }),
    finalizeSync: () => {},
    finalizeAsync: async () => {},
  };
}

function makeDb() {
  return {
    execSync: () => {},
    execAsync: async () => {},
    runSync: () => ({ lastInsertRowId: 0, changes: 0 }),
    runAsync: async () => ({ lastInsertRowId: 0, changes: 0 }),
    getAllSync: () => [],
    getAllAsync: async () => [],
    getFirstSync: () => null,
    getFirstAsync: async () => null,
    getEachSync: function* () {},
    getEachAsync: async function* () {},
    prepareSync: () => makeStatement(),
    prepareAsync: async () => makeStatement(),
    withTransactionSync: (cb) => { if (cb) cb(); },
    withTransactionAsync: async (cb) => { if (cb) await cb(); },
    withExclusiveTransactionAsync: async (cb) => { if (cb) await cb(makeDb()); },
    closeSync: () => {},
    closeAsync: async () => {},
    deleteSync: () => {},
    deleteAsync: async () => {},
  };
}

export function openDatabaseSync() { return makeDb(); }
export async function openDatabaseAsync() { return makeDb(); }
export function openDatabase() { return makeDb(); } // legacy API
export function deleteDatabaseSync() {}
export async function deleteDatabaseAsync() {}
export const SQLiteProvider = ({ children }) => children ?? null;
export function useSQLiteContext() { return makeDb(); }
export function addDatabaseChangeListener() { return { remove: () => {} }; }

export default {
  openDatabaseSync,
  openDatabaseAsync,
  openDatabase,
  deleteDatabaseSync,
  deleteDatabaseAsync,
  SQLiteProvider,
  useSQLiteContext,
  addDatabaseChangeListener,
};
